export const SIGN_IN = "sign_in"
export const SIGN_OUT = "sign_out"
export const VERIFY_LINE_ACCOUNT = "verify_line_account"
export const RESET_PASSWORD = "reset_password"